import React from 'react';
import PropTypes from 'prop-types';
import { Radio as RadioButton } from 'react-bootstrap';
import NumberUtils from '../../utils/NumberUtils';

class SavingPotComponent extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onClick(this.props.potData, true);
  }

  render() {
    const id = `${this.props.potData.id} ${this.props.name}`;
    const balanceAmt = NumberUtils.appendCurrency(
      '{}',
      this.props.potData.balance
    );
    return (
      <RadioButton
        id={id}
        name="radioGroupVertical"
        className="c-radio__vertical"
        value={this.props.potData.balance}
        onClick={this.onClick}
        defaultChecked={this.props.checked}
        disabled={this.props.disabled}
      >
        <label htmlFor={id} className="c-radio__label c-radio__label--border">
          <span className="c-radio__label--wrap">
            <h6 className="text pot-name pull-left">
              {this.props.potData.name}
            </h6>
            <h6 className="text pull-right">{balanceAmt}</h6>
          </span>
        </label>
      </RadioButton>
    );
  }
}

SavingPotComponent.propTypes = {
  potData: PropTypes.object,
  name: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

SavingPotComponent.defaultProps = {
  potData: {},
  checked: false,
  disabled: false,
  name: '',
};

export default SavingPotComponent;
